import _ from "lodash";
import { getOccupationMapping, getUnitizedValue } from "./auraHealthUtils";

function getAnswerTextFromValue(nextAuraQuestion, returnValue) {
  const returnChoice = _.find(nextAuraQuestion?.constraints?.choices, {
    value: returnValue,
  });
  return returnChoice?.text;
}

export function getReviewQuestionAnsweredValue(nextAuraQuestion) {
  switch (nextAuraQuestion?.type) {
    case "SINGLE_CHOICE":
      return getAnswerTextFromValue(
        nextAuraQuestion,
        nextAuraQuestion?.answer?.value
      );
    case "TEXT":
    case "NUMERIC":
    case "UNITIZED_CHOICE":
    case "DATE_CHOICE":
    case "NUMERIC_CHOICE":
      return nextAuraQuestion?.answer?.value;
    case "UNITIZED":
      return getUnitizedValue(nextAuraQuestion);
    case "MULTIPLE_CHOICE":
      return _.map(nextAuraQuestion?.answer?.answers, "value");
    case "SEARCH":
      return getOccupationMapping(nextAuraQuestion);
    case "BLOOD_PRESSURE":
      const lastBPreading = _.first(nextAuraQuestion?.answer?.readings);
      return {
        systolicReading: lastBPreading?.systolic,
        diastolicReading: lastBPreading?.diastolic,
      };
    case "DATE":
      return new Date(nextAuraQuestion?.answer?.value);
    default:
      return null;
  }
}
